import { Injectable } from "@angular/core";
import { Subject } from "rxjs";


const cacheBuster$ = new Subject<void>();

@Injectable()

/**
 *
 *
 * @export
 * @class mandatoryFieldsService
 */
export class mandatoryFieldsService {
  setMandatoryFormValues(_this: any[], _mandatorykeys: any, _showkeys: any) {
    _this.forEach((res) => {
      const key = res.key;
      if (key in _mandatorykeys) {
        _mandatorykeys[key] = res.systemMandatory === true;
      }
      if (key in _showkeys) {
        _showkeys[key] = res.showInScreen === true;
      }
    });
  }
}

